export default __webpack_public_path__ + "static/media/ic-wallet.7211041e.svg";